import {
  HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, throwError } from 'rxjs';
import { NimmstaCommonsModuleConfiguration } from '../nimmsta-commons-module.config';
import { OfflineService } from '../services/offline.service';

@Injectable()
export class StatusInterceptor implements HttpInterceptor {
  private urls: string[] = [];

  private router = inject(Router);
  private offlineService = inject(OfflineService);
  private configuration = inject(NimmstaCommonsModuleConfiguration);

  public constructor() {
    this.urls = [...Object.values(this.configuration.apiUrls), this.configuration.keycloakUrl];
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error) => {
        // Redirect to offline page if the server is not reachable
        if (
          error instanceof HttpErrorResponse
          && (this.containsUrl(error.url))
          && (!error.url?.includes('actuator/health'))
          && (
            error.status === 0
            || error.status === HttpStatusCode.BadGateway
            || error.status === HttpStatusCode.ServiceUnavailable
            || error.status === HttpStatusCode.GatewayTimeout
          )
          && !this.router.url.includes('/offline')
        ) {
          // // Close all modals (if any)
          // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
          //   this.modalService.hide(i);
          // }

          // Mark Service as offline
          const findServerUrl = this.urls.find((url) => error.url?.includes(url));
          if (findServerUrl) {
            this.offlineService.setOffline(findServerUrl);
          }
        }
        return throwError(() => error);
      }),
    );
  }

  private containsUrl(url?: string | undefined | null): boolean {
    if (!url) {
      return false;
    }
    return this.urls.some((u) => url.includes(u));
  }
}
